import { render } from "./BulkUpdatePhaseDialog.vue?vue&type=template&id=4783bc76&scoped=true"
import script from "./BulkUpdatePhaseDialog.vue?vue&type=script&lang=js"
export * from "./BulkUpdatePhaseDialog.vue?vue&type=script&lang=js"

import "./BulkUpdatePhaseDialog.vue?vue&type=style&index=0&id=4783bc76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4783bc76"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QForm,QCheckbox,QInput,QBtn,QSelect});qInstall(script, 'directives', {ClosePopup});
